import { invoiceLocaleToLanguage } from '@features/invoices/constants/invoiceLocaleToLanguage'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import {
  FieldInterface,
  FieldsInterface,
  ZervantSettingsModel,
} from '@features/invoicingSettings/types/zervantSettingsModel'

import { NumberValue } from '../../../../../../../../utils'
import { InvoiceSettingsForm } from '../../types/invoiceSettingsForm'

export const getModelsPayload = (
  models: ZervantSettingsModel[],
  formData: InvoiceSettingsForm,
): ZervantSettingsModel[] => {
  const fieldToFormValue: Partial<Record<keyof FieldsInterface, Partial<Pick<FieldInterface, 'default' | 'visible'>>>> =
    {
      currency: { default: formData.currency },
      customerNumber: { visible: formData.shouldShowCustomerId },
      description: { default: formData.message },
      footerText: { default: formData.footerNote },
      language: { default: invoiceLocaleToLanguage[formData.language] || 'en' },
      legalterms: { default: formData.termsAndConditions, visible: formData.shouldShowTermsAndConditions },
      paymentTime: { default: new NumberValue(formData.paymentTerm).getStringValue() },
      productType: { default: formData.productType },
    }

  return models.map((model) => {
    if (model.type !== InvoiceDocumentType.Invoice) {
      return model
    }

    const updatedFields = model.fields.map((field) => {
      if (field.name in fieldToFormValue) {
        return { ...field, ...fieldToFormValue[field.name] }
      } else {
        return field
      }
    })

    return { ...model, fields: updatedFields }
  })
}
